<template>
  <div v-if="typeof product == 'object' && (!isBasket || localQuantity > 0)" class="cr-product-card">
    <div class="cr-product-card__main">
    <router-link class="cr-product-card__title" :to="'/detail/'+product.id+'/'">
      {{ product.name }}
    </router-link>
    <router-link :to="'/detail/'+product.id+'/'" class="cr-product-card__body">
      <div class="cr-product-card__left" v-if="product.picture">
        <picture class="cr-product-card__picture">
          <img class="cr-product-card__image" :src="product.picture" width="120" height="144" alt="">
        </picture>
      </div>
      <div class="cr-product-card__right">
        <ul class="cr-product-card__labels cr-labels">
          <li v-if="product.is_hit" class="cr-labels__item cr-labels__item--green">
            ХИТ
          </li>
          <li v-if="product.is_new" class="cr-labels__item cr-labels__item--blue">
            NEW
          </li>
          <li v-if="product.is_sale" class="cr-labels__item cr-labels__item--red">
            SALE
          </li>
        </ul>
        <div v-if="product.brand && product.brand.name" class="cr-product-card__brand cr-brand">
                                                        <span class="cr-brand__line">
                                                            <span v-if="product.brand.image" class="cr-brand__logo">
                                                                <img class="cr-brand__logo-image" :src="product.brand.image" width="16" height="16" alt="">
                                                            </span>
                                                            <span class="cr-brand__name">
                                                                {{ product.brand.name }}
                                                            </span>
                                                        </span>
        </div>
        <div class="cr-product-card__description" v-if="product.style">
          {{ product.style }}
        </div>
        <div class="cr-product-card__package">
                                                        <span v-if="product.tip_tary" class="cr-product-card__package-name">
                                                            {{ product.tip_tary }} {{ product.obem_tary }}
                                                        </span>
          <span v-if="product.measure" class="cr-product-card__package-size">
                                                             {{ product.measure }}
                                                        </span>
        </div>
        <dl class="cr-product-card__characteristics-list">
          <div v-if="product.abv" class="cr-product-card__characteristics-item">
            <dt class="cr-product-card__characteristics-term">
              ABV
            </dt>
            <dd class="cr-product-card__characteristics-value">
              {{ product.abv }}
            </dd>
          </div>
          <div v-if="product.og" class="cr-product-card__characteristics-item">
            <dt class="cr-product-card__characteristics-term">
              OG
            </dt>
            <dd class="cr-product-card__characteristics-value">
              {{ product.og }}
            </dd>
          </div>
          <div v-if="product.ibu" class="cr-product-card__characteristics-item">
            <dt class="cr-product-card__characteristics-term">
              IBU
            </dt>
            <dd class="cr-product-card__characteristics-value">
              {{ product.ibu }}
            </dd>
          </div>
        </dl>
        <div v-if="isBasket || isOrder" class="cr-product-card__price cr-price">
                                                            <span class="cr-price__current">
                                                                {{ formatPrice(product.price) }} ₽
                                                            </span>
          <span v-if="product.price_old > product.price" class="cr-price__old">
                                                                {{ product.price_old }}₽
                                                            </span>
        </div>
        <div class="cr-product-card__quantity">
          <span class="cr-product-card__quantity-value cr-product-card__quantity-value--low"></span>
        </div>
      </div>
    </router-link>
    </div>
    <button v-if="isBasket" @click="remove()" class="cr-product-card__button-delete simulated-hover" type="button">
      <svg width="25" height="25" viewBox="0 0 25 25">
        <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-3"></use>
      </svg>
    </button>
    <div v-if="!isOrder" class="cr-product-card__bottom">
      <div v-if="isBasket" class="cr-product-card__total">
                                                    <span class="cr-product-card__total-label">
                                                        Всего
                                                    </span>
        <span class="cr-product-card__total-number">
                                                        {{ formatPrice(localQuantity * product.price) }} ₽
                                                    </span>
      </div>
      <div v-if="!isBasket" class="cr-product-card__price cr-price">
                                                    <span v-if="product.price_old > product.price" class="cr-price__old">
                                                        {{ product.price_old }} ₽
                                                    </span>
        <span class="cr-price__current">
                                                        {{ formatPrice(product.price) }} ₽
                                                    </span>
      </div>
      <button v-if="localQuantity === 0" @click="addToBasket({productId:product.id, quantity: 1})" class="cr-product-card__button cr-button cr-button--border" type="button">
                                    <span class="cr-button__text">
                                        Добавить в корзину
                                    </span>
      </button>
      <div v-if="localQuantity === '' || localQuantity > 0" class="cr-product-card__counter cr-counter">
        <div class="cr-counter__wrapper">
          <button @click="handleDecrement(product.ratio)" class="cr-counter__button js-button-minus simulated-hover" type="button">
            <svg class="cr-counter__button-icon" width="14" height="14" viewBox="0 0 14 2">
              <use xlink:href="/assets/img/svg/sprite.svg#minus"></use>
            </svg>
          </button>
          <input class="cr-counter__qty" type="number" data-step="1" v-model.number="localQuantity"
                 @input="handleInput"
                 min="0"
                 :max="product.available"

          >
          <button @click="handleIncrement(product.ratio)" class="cr-counter__button js-button-plus simulated-hover" type="button">
            <svg class="cr-counter__button-icon" width="14" height="14" viewBox="0 0 14 14">
              <use xlink:href="/assets/img/svg/sprite.svg#plus"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div v-if="isOrder" class="cr-product-card__bottom">
      <div class="cr-product-card__qty">
        <span class="cr-product-card__qty-current"> {{ product.quantity_original }} шт. </span>
        <span class="cr-product-card__qty-old" v-if="product.quantity_original != product.quantity"> {{ product.quantity_original }} шт. </span>
      </div>
      <div class="cr-product-card__sum"> {{ product.sum }} ₽ </div></div>
  </div>
</template>

<script>
import product from "@/mixin/product.vue";

export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      required: true
    },
    isBasket: {
      type: Boolean,
      required: false,
      default: false
    },
    isOrder: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      localQuantity: 0
    }
  },
  mixins: [product],
  methods: {
    updateLocalQuantity(val) {
      this.localQuantity = val;
    }
  }
}
</script>